<app-profile-photo
  [user]="user"
  [width]="width"
  [fromQuestionList]="fromQuestionList"
  [showName]="showName"
  [institution]="institution"
  [isClickEnabled]="isClickEnabled"
></app-profile-photo>
